import gql from 'graphql-tag';

export const GET_SUBSCRIBER_PURCHASE_PATTERNS_BY_SEGMENT = gql`
  query getPurchasesBySubWithMulPurchasesBySegment($params: ReportInput!) {
    purchasesBySubWithMulPurchasesBySegment(params: $params) {
      merchantName
      segmentId
      totalPurchases
      numberOfTransactors
      merchantTotal
      percentOfMerchantTotal
      aov
      startDate
      endDate
    }
  }
`;

export const GET_SUBSCRIBER_PURCHASE_PATTERNS = gql`
  query getPurchasesBySubWithMulPurchases($params: ReportInput!) {
    purchasesBySubWithMulPurchases(params: $params) {
      merchantName
      cashbackPercentage
      totalPurchases
      numberOfTransactors
      merchantTotal
      percentOfMerchantTotal
      aov
      startDate
      endDate
    }
  }
`;

export default GET_SUBSCRIBER_PURCHASE_PATTERNS;
